"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = exports.loadSpinner = exports.DelayedFallback = exports.LoadSpinnerWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LoadSpinnerModule = _interopRequireDefault(require("./LoadSpinner.module.scss"));

// 过渡loader容器
var LoadSpinnerWrapper = function LoadSpinnerWrapper(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _LoadSpinnerModule["default"].wrapper + " " + className,
    style: style
  }, children);
}; // 延迟fallback


exports.LoadSpinnerWrapper = LoadSpinnerWrapper;

var DelayedFallback = function DelayedFallback(_ref2) {
  var _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 300 : _ref2$delay,
      children = _ref2.children;

  var _useState = (0, _react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  (0, _react.useEffect)(function () {
    var timeout = setTimeout(function () {
      return setShow(true);
    }, delay);
    return function () {
      clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show && children);
};
/**
 * 加载过渡的loader
 * @param {*} spinner 加载过渡的组件
 * @param {*} options 选项, {
 *     spinner:spinner, // loading动画组件, 默认为loadSpinner,
 *     pastDelay:300, // fallback显示的延迟时间, 默认300ms,
 * isLoading: true, // 强制加载/不加载
 * error: false, // 强制报错
 * }
 */


exports.DelayedFallback = DelayedFallback;

var loadSpinner = function loadSpinner(spinner, options) {
  if (spinner === void 0) {
    spinner = /*#__PURE__*/_react["default"].createElement("div", {
      className: _LoadSpinnerModule["default"].loader
    });
  }

  if (options === void 0) {
    options = {};
  }

  var tOptions = Object.assign({
    pastDelay: 300,
    isLoading: true,
    error: false
  }, options);
  var isLoading = tOptions.isLoading,
      pastDelay = tOptions.pastDelay,
      error = tOptions.error;

  if (error) {
    return /*#__PURE__*/_react["default"].createElement(LoadSpinnerWrapper, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, "\u52A0\u8F7D\u5931\u8D25\uFF0C"), /*#__PURE__*/_react["default"].createElement("span", {
      className: _LoadSpinnerModule["default"].error,
      onClick: function onClick() {
        window.location.reload();
      }
    }, "\u70B9\u51FB\u5237\u65B0")));
  }

  if (isLoading) {
    if (pastDelay) {
      return /*#__PURE__*/_react["default"].createElement(LoadSpinnerWrapper, null, /*#__PURE__*/_react["default"].createElement(DelayedFallback, {
        delay: pastDelay
      }, spinner));
    }

    return /*#__PURE__*/_react["default"].createElement(LoadSpinnerWrapper, null, spinner);
  }

  return null;
};

exports.loadSpinner = loadSpinner;

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement("div", null, loadSpinner());
};

exports["default"] = _default;